"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = require("@material-ui/core/Icon");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const NoResultsFoundStyle_1 = require("./jss/NoResultsFoundStyle");
const NoResultsFound = ({ title, classes }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.root }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { className: (0, classnames_1.default)('icon-search-no-results', classes.icon) }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", component: "span", className: classes.title }, { children: title }))] })));
exports.default = (0, styles_1.withStyles)(NoResultsFoundStyle_1.default)(NoResultsFound);
//# sourceMappingURL=NoResultsFound.js.map